module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/algoliasearch/src/clone.js
// module id = 560
// module chunks = 0 1 2 3 4 5 6 7 8